import GpsCargoOrderRecordsResponse, {
  GpsCargoOrderRecordsResponseItem,
} from "../../../api/raily/gps/cargo-order-records/gps-cargo-order-records-response";
import GpsCargoOrderRecord from "./gps-cargo-order-records";

const createRecord = (
  item: GpsCargoOrderRecordsResponseItem,
): GpsCargoOrderRecord => {
  return {
    lat: item.lat,
    lon: item.lon,
    recordTime: item.recordTime,
  };
};

const create = (
  response: GpsCargoOrderRecordsResponse,
): GpsCargoOrderRecord[] => {
  return response.data.map(createRecord);
};

const gpsCargoOrderRecordsFactory = {
  create,
};

export default gpsCargoOrderRecordsFactory;
